import { Button, Check, Loader2 } from '@chain-zen/ui'

import type { IELDAsset } from '../../../../../../../data/queries/eld-apps'

interface IModalFooterProps {
  isConfirmDisabled: boolean
  isLoadingUpdate: boolean
  onBackClick: () => void
  onCancelClick: () => void
  onConfirmClick: () => void
  selectedItem: IELDAsset | null
  step: 1 | 2
}

/**
 * Footer component for the truck/trailer selection modal.
 * Shows Back/Cancel button and Confirm button with loading state.
 */
export const ModalFooter = ({
  isConfirmDisabled,
  isLoadingUpdate,
  onBackClick,
  onCancelClick,
  onConfirmClick,
  selectedItem,
  step
}: IModalFooterProps) => {
  const handleSecondaryClick = () => {
    if (step === 2) {
      onBackClick()
    } else {
      onCancelClick()
    }
  }

  const renderConfirmContent = () => {
    if (isLoadingUpdate) {
      return (
        <>
          <Loader2 className="w-4 h-4 animate-spin" />
          <span>Updating...</span>
        </>
      )
    }

    if (selectedItem) {
      return (
        <>
          <span>Select {selectedItem.assetNumber}</span>
          <Check className="w-4 h-4" />
        </>
      )
    }

    return step === 1 ? 'Select an ELD' : 'Select an asset'
  }

  return (
    <div className="px-5 py-3 border-t border-border flex gap-2.5 shrink-0">
      <Button onClick={handleSecondaryClick} variant="ghost" className="flex-1">
        {step === 2 ? 'Back' : 'Cancel'}
      </Button>
      <Button onClick={onConfirmClick} disabled={isConfirmDisabled} className="flex-1">
        {renderConfirmContent()}
      </Button>
    </div>
  )
}
